import React, { useState, useEffect } from 'react';
import './Notice.css'; // CSS 파일을 import
import { Link } from "react-router-dom";
import waitline from './assets/waitline.png'; // 이미지 import

const MIN_SPEED = 1.5;
const MAX_SPEED = 2.5;

function randomNumber(min, max) {
  return Math.random() * (max - min) + min;
}

class Blob {
  constructor(el) {
    this.el = el;
    const boundingRect = this.el.getBoundingClientRect();
    this.size = boundingRect.width;
    this.initialX = randomNumber(0, window.innerWidth - this.size);
    this.initialY = randomNumber(0, window.innerHeight - this.size);
    this.el.style.top = `${this.initialY}px`;
    this.el.style.left = `${this.initialX}px`;
    this.vx = randomNumber(MIN_SPEED, MAX_SPEED) * (Math.random() > 0.5 ? 1 : -1);
    this.vy = randomNumber(MIN_SPEED, MAX_SPEED) * (Math.random() > 0.5 ? 1 : -1);
    this.x = this.initialX;
    this.y = this.initialY;
  }

  update() {
    this.x += this.vx;
    this.y += this.vy;
    if (this.x >= window.innerWidth - this.size) {
      this.x = window.innerWidth - this.size;
      this.vx *= -1;
    }
    if (this.y >= window.innerHeight - this.size) {
      this.y = window.innerHeight - this.size;
      this.vy *= -1;
    }
    if (this.x <= 0) {
      this.x = 0;
      this.vx *= -1;
    }
    if (this.y <= 0) {
      this.y = 0;
      this.vy *= -1;
    }
  }

  move() {
    this.el.style.transform = `translate(${this.x - this.initialX}px, ${this.y - this.initialY}px)`;
  }
}

function Notice() {
  const [modalVisible, setModalVisible] = useState(false);
  const [currentNotice, setCurrentNotice] = useState('');
  const [description, setDescription] = useState('');
  const [clickedButton, setClickedButton] = useState(null);

  useEffect(() => {
    const initBlobs = () => {
      const blobEls = document.querySelectorAll('.bouncing-blob');
      const blobs = Array.from(blobEls).map((blobEl) => new Blob(blobEl));

      function update() {
        requestAnimationFrame(update);
        blobs.forEach((blob) => {
          blob.update();
          blob.move();
        });
      }

      requestAnimationFrame(update);
    };

    initBlobs();
  }, []);

  const openModal = (notice, buttonIndex) => {
    let descriptionText = "";
    switch(notice) {
      case "교내 편의점 주류 판매 안내":
        descriptionText = '아우름제를 맞이하여 교내 편의점 \n (학생회관 CU, 김수환관 이마트 24)에서 \n 한시적으로 주류를 판매하오니 참고바랍니다.';
        break;
      case "부스 운영 시간":
        descriptionText = `
        📍노점
        ▶ 노점 부스 운영시간
        - 22일 10:00-17:00
        - 23일 10:00-16:00

        📍주점
        ▶ 주점 부스 운영시간
        - 22일 수요일 18:00-24:00
        - 23일 목요일 18:00-02:00(익일)

        📢티켓 수령 장소/시간
        장소: 예수성심광장 축제운영본부
        ▶ 수령 시간
        - 23일 목요일 10:00 ~ 16:00
        `;
        break;
      case "재학생 입장 시간":
        descriptionText = `
        아우름제가 진행되는 이번 5월 22일, 5월 23일 이틀간 축제기간
        
        재학생 입장 가능 시간에 대해 안내드립니다.

        📌 5/22-23(수-목)
        가톨릭대학교 구성원 입장 : 14:00 ~ 상시 개방
        🚨아우름제 티켓/학생증/트리니티 (택1) 학적 인증 필요
        
        감사합니다.`;
        break;
      case "축제 기간금 기숙사 통금 시간":
        descriptionText = `
        아우름제가 진행되는 이번 5월 22일, 5월 23일 이틀간 축제기간
        
        기숙사 통금 시간 변경에 대해 안내드립니다.

        기숙사 통금 시간을 아래와 같이 연장합니다.
        확인하시고 기숙사 사용에 착오 없으시길 바랍니다‼️
        
        📌 5/22-23(수-목)
        전체 : 익일 02:00
        
        감사합니다.`;
        break;
      case "입장 시 대기줄 안내":
        descriptionText = "";
        break;

      case "반입 금지 물품":
        descriptionText = `
        ⚠️주위 관객들을 해칠 수 있는 위험한 물건⚠️

        
        📷허가받지 않은 전문 촬영 장비
        (ex. 삼각대 / DSLR 등)


        ⛏️무대 연출에 방해가 되는 물품
        (ex. 레이저 포인터등)


        ☠️관련 사항 미준시 시, 발생하는 문제에 대해
        주최 측은 책임지지 않습니다.
        
        `;
        break;

        case "2024 아우름제 드레스코드":
        descriptionText = `
        바로 💙 BLUE&WHITE 🤍 입니다.


        `;
        break;

        case "자세한 정보":

        break;

      default:
        descriptionText = "상세 설명이 없습니다.";
    }
    
    setCurrentNotice(notice);
    setDescription(descriptionText);
    setClickedButton(buttonIndex);
    setModalVisible(true);
  };

  const closeModal = () => {
    setModalVisible(false);
  };

  const handleDetailInfoClick = () => {
    window.location.href = 'https://www.instagram.com/festival_cuk/';
  };

  return (
    <div className="App">
      <div className="bouncing-blobs-container">
        <div className="bouncing-blobs-glass"></div>
        <div className="bouncing-blobs">
          <div className="bouncing-blob bouncing-blob--blue"></div>
          <div className="bouncing-blob bouncing-blob--blue"></div>
          <div className="bouncing-blob bouncing-blob--blue"></div>
          <div className="bouncing-blob bouncing-blob--white"></div>
          <div className="bouncing-blob bouncing-blob--purple"></div>
          <div className="bouncing-blob bouncing-blob--purple"></div>
          <div className="bouncing-blob bouncing-blob--pink"></div>
        </div>
      </div>
      <div className="hero"></div>

      {!modalVisible && (
        <div className="vertical-buttons">
          <button className={`rectangle-button ${clickedButton === 7 ? 'clicked' : ''}`} onClick={() => openModal("2024 아우름제 드레스코드", 1)}>2024 아우름제 드레스코드</button>
          <button className={`rectangle-button ${clickedButton === 1 ? 'clicked' : ''}`} onClick={() => openModal("교내 편의점 주류 판매 안내", 1)}>교내 편의점 주류 판매 안내</button>
          <button className={`rectangle-button ${clickedButton === 2 ? 'clicked' : ''}`} onClick={() => openModal("부스 운영 시간", 2)}>부스 운영 시간</button>
          <button className={`rectangle-button ${clickedButton === 3 ? 'clicked' : ''}`} onClick={() => openModal("재학생 입장 시간", 3)}>재학생 입장 시간</button>
          <button className={`rectangle-button ${clickedButton === 4 ? 'clicked' : ''}`} onClick={() => openModal("축제 기간금 기숙사 통금 시간", 4)}>축제 기간 기숙사 통금 시간</button>
          <button className={`rectangle-button ${clickedButton === 5 ? 'clicked' : ''}`} onClick={() => openModal("입장 시 대기줄 안내", 5)}>입장 시 대기줄 안내</button>
          <button className={`rectangle-button ${clickedButton === 6 ? 'clicked' : ''}`} onClick={() => openModal("반입 금지 물품", 6)}>반입 금지 물품</button>
          <button className={`rectangle-button ${clickedButton === 7 ? 'clicked' : ''}`} onClick={handleDetailInfoClick}>자세한 정보</button>
        </div>
      )}
      {!modalVisible && (
        <Link to="/" className="link">
          <button className="back-to-top" onClick={() => window.scrollTo(0, 0)}>BACK</button>
        </Link>
      )}

      {modalVisible && (
        <div className="modal" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-head">
              <h2>{currentNotice}</h2>
              <div className="underline"></div>
            </div>
            <div className="modal-body" style={{ whiteSpace: 'pre-line' }}>
              {description}
              {currentNotice === "입장 시 대기줄 안내" && (
                <div>
                  <img src={waitline} alt="Waitline" className="modal-image" />
                  <p className='c'><span className='text_red'>빨간색</span> : 재학생 대기줄 (14:00 부터)</p>   
                  <p className='c'><span className='text_blue'>파란색</span> : 외부인 대기줄 (18:00 부터)</p>
                  


                </div>
              )}
            </div>
            <button className="backbtn" onClick={closeModal}>이전 화면으로</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Notice;
